import React from 'react';
import { hideModal, setShowModal } from '../redux/features/oxygen/customModalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { OxygenManualReviewDecision } from '../services/oxygenRetailServices';
import useCustomAlert from './Alert2';
import { updatePrecustomer } from '../redux/features/precustomers/PrecustomerSlice';


const OxygenManualReview = ({data}) => {
    const dispatch = useDispatch();
    const customAlert = useCustomAlert();
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const storePrecustomer = useSelector(
        (state) => state?.precustomer?.precustomerData
    );
        
    const handleProceed = async () => {
        setLoading(true);
        const payload = {
            msisdn: data?.msisdn
        }

        const res = await OxygenManualReviewDecision(payload);

        if(res?.status === true && res?.responseCode === "Complete") {
            dispatch(
                updatePrecustomer({
                ...storePrecustomer,
                onboarding_status: "validate-otp-oxygen"
                })
            );
            dispatch(hideModal());
            customAlert.showToast("success", res?.message || "Success");
            navigate("/oxygenForm-OTP"); 

        }else if (res?.status === false && res?.responseCode === "Complete") {
            customAlert.showToast("error", res?.message || "Failed");
            dispatch(hideModal());
        }else if (res?.status === false && res?.responseCode === "Pending") {
            customAlert.showToast("error", res?.message || "Failed");
            // manual review modal
            dispatch(setShowModal({
                status:true,
                title:"Manual Review",
                type:"manualReview",
                showCloseButton:false,
                data:{message:res?.message, msisdn:storePrecustomer?.precustomer?.msisdn},
            }));
        }else{
            customAlert.showToast("error", res?.message || "Failed");
            dispatch(hideModal());
        }
        setLoading(false);
    }

  return (
    <div className="card">
        <div className="card-header">
        <h3 className="mb-0 card-title text-info">
            Kindly click on the review button to proceed
        </h3>
        </div>
        <div className="card-body">
        <div className="row">
            <div className="col-md-12 mb-4">
            <div className="d-flex flex-column align-items-start my-2">
                <div className='mb-2' style={{ fontSize: "18px", color: "black" }}>
                    {data?.message ? `${data?.message} , Please click the 'Review' button after 15 minutes to check the status.` : "Your request is pending manual review, Please click the 'Review' button after 15 minutes to check the status."}  
                </div>
            </div>
            </div>

        <div className="col-md-12">
            <div className="form-group d-flex justify-content-center align-items-center gap-5">
                <button className="btn btn-secondary" onClick={() => dispatch(hideModal())}>
                    <b>Cancel</b>
                </button>
                <button className="btn btn-primary" onClick={handleProceed}>
                    <b>{loading ? "Please wait..." : "Review"}</b>
                </button>
            </div>
        </div>

        </div>
        </div>
    </div>
  )
}

export default OxygenManualReview;